<template>
  <main class="exam-warning">
    <section class="exam-warning__content">
      <div class="exam-warning__icon-wrapper">
        <div class="exam-warning__circle">
          <FileTextSvg />
        </div>
        <div class="exam-warning__info">
          <InfoWarningCircle />
        </div>
      </div>

      <p class="exam-warning__message" v-if="showLabel">
        Houve um problema ao receber seus arquivos
      </p>
    </section>
    <section class="bottomContainer">
      <ContinueWithoutMedicalOrderButton @click="$emit('secondary-action')" />
    </section>
  </main>
</template>

<script>
import FileTextSvg from '@/assets/img/icons/file-text-component.svg?inline';
import InfoWarningCircle from '@/assets/img/icons/info-warning-circle.svg?inline';
import ContinueWithoutMedicalOrderButton from './ContinueWithoutMedicalOrderButton.vue';

export default {
  components: {
    FileTextSvg,
    InfoWarningCircle,
    ContinueWithoutMedicalOrderButton,
  },
  props: {
    showLabel: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.exam-warning {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0;

  &__content {
    flex: 1;
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__icon-wrapper {
    position: relative;
    display: inline-block;
  }

  &__circle {
    background-color: #fef1e6;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    svg path {
      fill: #d26404;
    }
  }

  &__info {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__message {
    font-family: 'Dasa sans', sans-serif;
    font-weight: var(--font-weight-bold);
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #161616b8;
    margin-top: 16px;
  }
}
</style>
